export const listSanitizer = params => {
  const sanitizedParams = {
    page: params.page,
    perPage: params.perPage || params.rowsPerPage
  };

  return sanitizedParams;
};

export const createSanitizer = params => {
  const sanitizedParams = {
    pointOfSaleIds: params.pointOfSales
      .map(pointOfSale => pointOfSale.value)
      .join(','),
    categoryId: Number(params.categoryId),
    geographicLocationId: Number(params.geographicLocationId)
  };

  return sanitizedParams;
};

export const updateSanitizer = params => {
  const sanitizedParams = {
    pointOfSaleId: Number(params.pointOfSaleId),
    categoryId: Number(params.categoryId),
    geographicLocationId: Number(params.geographicLocationId)
  };

  return sanitizedParams;
};

export const categoriesSanitizer = categories => {
  return categories.map(category => {
    return {
      id: category.id,
      active: category.active,
      depth: category.depth,
      name: category.name
    };
  });
};
